import { render, staticRenderFns } from "./ManageWarrants3Reminders.vue?vue&type=template&id=b41679cc&scoped=true"
import script from "./ManageWarrants3Reminders.vue?vue&type=script&lang=js"
export * from "./ManageWarrants3Reminders.vue?vue&type=script&lang=js"
import style0 from "./ManageWarrants3Reminders.vue?vue&type=style&index=0&id=b41679cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41679cc",
  null
  
)

export default component.exports